import React, { useState, useEffect } from 'react';
import axios from "axios";
import './CSS/PokemonSelector.css'
import { useHistory } from 'react-router-dom';


const PokemonSelector = () => {

    const [pokes, setPokes] = useState([]);
    const [types, setTypes] = useState([]);
    const [value, setValue] = useState('')
    let history = useHistory()
  
 

    const fetchPokemon = async(data)=>{
        try{
            let res = await axios.get("https://pokeapi.co/api/v2/type/")
    
            let data = res.data.results
            
            setTypes(data) 

        }catch(error){
            setTypes([])
            console.log(error)

        }
        
    }
    useEffect(() => {
        fetchPokemon();
    }, [])
   
    const options = types.map((el) => {
        return <option value={el.url} key={el.name}>{el.name}</option> 
    })


    const handleSubmit = async (e) => {
        e.preventDefault()
        const submitPokemon = async()=>{
                try{
                    let response = await axios.get(value)
                    let pokeValue = response.data.pokemon
                   
                    
                    setPokes(pokeValue)
               
                }catch(error){
                    setPokes([])
                }

        }
        submitPokemon()
    }

    const handleSelect= ()=>{

        
    }
    const click = (event) =>{

        event.preventDefault();
        history.push({
            pathname: `/pokemon/${event.target.value}`,
            state: { url: event.target.id }
        })
    }
    const listTypes = pokes.map((el) => {
       
        return (
     <button className ="names"value={el.pokemon.name} key={el.pokemon.name}id={el.pokemon.url}onClick={click}>

       {el.pokemon.name} 
     </button>
        )
    })
    const selectPoke = (event) => {
        setValue(event.target.value)
        return ({value, onChange: selectPoke})
    }


 

    return (
        <div className="pokemonSelect">
       <form onSubmit ={handleSubmit}>

       <select 
                onChange={(e) => setValue(e.target.value)}{...selectPoke}>
                <option defaultValue>Select Pokemon Type</option>
                {options}
            </select>
            
            <button className="submitBtn">Submit</button>

       </form>
             {listTypes}
       <div className="pokeball">
             <div className="upper-half"> </div>
      <div className="lower-half"> </div>
      <div className="base"> </div>
      <div className="inner-circle"> </div>
      <div className="indicator visible"> </div>
      <div className="indicator-inner"> </div>
         
       </div>


        </div>
    )

}


export default PokemonSelector;